import { createEntityAdapter } from '@reduxjs/toolkit';
import * as i from './lookupsInterfaces';

export const lookupEntityAdapters = {
  companyDimensions: createEntityAdapter<i.ICompanyDimension>({
    selectId: x => x.companyDimensionId,
    sortComparer: (a, b) => a.name.localeCompare(b.name)
  }),
  dpShipMethods: createEntityAdapter<i.IDpShipMethod>({
    selectId: x => x.value,
    sortComparer: (a, b) => a.value.localeCompare(b.value)
  }),
  pickLists: createEntityAdapter<i.IPickList>({
    selectId: x => x.pickListId
  })
} as const;
